module.exports = __webpack_public_path__ + "img/8blue.7ac24ed8.png";